import { Figure } from 'react-bootstrap'
import { BsPrefixRefForwardingComponent } from 'react-bootstrap/esm/helpers'
import styled, { css } from 'styled-components'

const spartanNormal1618 = css`
    font-family: ${properties => properties.theme.variables.fontFamily.description};
    font-style: normal;
    font-size: 16px;
    line-height: 18px;
    font-weight: 600;
`

export const SuccessHeader = styled.header`
    width: 100%;
    margin: 0 auto;
    padding: 12px 0;
`

export const SuccessTitle = styled.h2`
    ${spartanNormal1618}
    line-height: 120%;
    font-size: 28px;
    color: ${properties => properties.theme.variables.colorText};

    @media screen and (max-width: 1200px) {
        font-size: 24px;
    }
    @media screen and (max-width: 810px) {
        font-size: 20px;
    }
    @media screen and (max-width: 390px) {
        font-size: 20px;
    }
`

export const SuccessAssetContainer = styled.section`
    width: 100%;
    background-color: transparent;
`

export const SuccessArticle = styled.article`
    display: flex;
    margin: 0 auto;
    flex-direction: column;
    width: 100%;
    gap: 2rem;
    hr {
        margin: 8px 0;
        border: 1px solid ${properties => properties.theme.variables.colorGray.secondary};
        border-bottom: 0;
    }
    @media only screen and (min-width: 810px) {
        hr {
            margin: 12px 0;
        }
        flex-direction: row;
    }
`

export const SuccessNavigator = styled.nav`
    display: flex;
    flex-direction: column;
    width: 100%;
    justify-content: space-between;
    max-height: 400px
    padding-top: 0;
    @media only screen and (max-width: 900px) {
        min-width: unset;
    }
    @media only screen and (min-width: 810px) {
        width: 100%;
        padding-top: 16px;
    }
`

export const SuccessNavItemDivider = styled.div`
    border: 1px solid ${properties => properties.theme.variables.colorGray.secondary};
    margin: 0;
`

interface ISuccessNavItemProperties {
    isRow?: boolean
}

export const SuccessNavItem = styled.div<ISuccessNavItemProperties>`
    display: ${properties => (properties.isRow ? 'flex' : 'block')};
    width: max-content;
`

export const SuccessNavItemTitle = styled.h3`
    font-family: ${properties => properties.theme.variables.fontFamily.title};
    font-weight: 600;
    font-size: 14px;
    padding: 0px;
    line-height: 1.2em;
    margin-bottom: 10px;
    color: ${properties => properties.theme.variables.colorText};
`

export const SuccessNavItemTitleMain = styled.div`
    display: flex;
    justify-content: space-between;
    span {
        font-family: ${properties => properties.theme.variables.fontFamily.title};
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 1.2em;
        text-align: left;
        color: ${properties => properties.theme.variables.colorText};
        padding-left: 14px;
    }
`

export const SuccessNavItemLinkContainer = styled.div<ISuccessNavItemProperties>`
    margin-top: 0;
    display: flex;
    align-items: flex-start;
    gap: 12px;
    a {
        display: flex;
        justify-content: center;
        height: 24px;
        font-family: ${properties => properties.theme.variables.fontFamily.description};
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 150%;
        color: ${properties => properties.theme.variables.colorPrimary};
        text-decoration: none;
        margin: 0;
    }
    svg {
        margin-right: unset;
        path {
            stroke: ${properties => properties.theme.variables.colorPrimary};
            fill: ${properties => properties.theme.variables.colorPrimary};
        }
        @media only screen and (max-width: 810px) {
            margin: unset;
        }
    }
    div {
        display: flex;
        gap: 10px;
        flex-direction: row;
    }
    @media only screen and (min-width: 810px) {
        flex-direction: column;
    }
`

interface ISuccessLinksProperties {
    socialMedia?: boolean
}

export const SuccessLinks = styled.a<ISuccessLinksProperties>`
    margin-top: 0rem;
    height: 13px;

    font-family: ${properties => properties.theme.variables.fontFamily.description};
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 13px;
    text-transform: capitalize;

    color: ${properties => properties.theme.variables.colorPrimary};

    svg {
        path {
            stroke: ${properties => properties.theme.variables.colorPrimary};
            fill: ${properties => (properties.socialMedia ? 'none' : properties.theme.variables.colorPrimary)};
        }
    }

    &:hover {
        color: ${properties => properties.theme.variables.colorPrimary};
        opacity: 0.8;
        svg {
            path {
                /* stroke: ${properties => properties.theme.variables.colorPrimary};
                fill: ${properties => properties.theme.variables.colorPrimary}; */
                opacity: 0.8;
            }
        }
    }
`

export const SuccessFigure: BsPrefixRefForwardingComponent<'figure', unknown> = styled(Figure)`
    margin: 0;
    width: 100%;
    max-height: 420px;
    display: flex;
    align-items: center;
    @media only screen and (min-width: 810px) {
        flex-direction: column;
        align-items: flex-start;
        max-height: unset;
        gap: 10px;
    }
`
